export const regions: Record<string, string> = {
  AF: 'Africa',
  AS: 'Asia & Pacific',
  SA: 'Central & South America',
  EU: 'Europe',
  NA: 'North America',
};
